import { GlobalAxios } from "../axios/axios-config";
import {
  INewTicketAutoInactiveRule,
  ITicketAutoInactiveRule,
} from "../models/ticket-auto-inactive-rule";

const TICKET_AUTO_INACTIVE_ROUTE =
  process.env.REACT_APP_TICKETS + "/api/v1/TicketAutoInactiveRule";

export const createTicketAutoInactiveRule = (
  item: INewTicketAutoInactiveRule,
) => {
  return GlobalAxios.post(TICKET_AUTO_INACTIVE_ROUTE, item);
};

export const getTicketAutoInactiveRuleById = (id: string) => {
  return GlobalAxios.get<ITicketAutoInactiveRule>(
    TICKET_AUTO_INACTIVE_ROUTE + "/" + id,
  );
};

export const updateTicketAutoInactiveRuleById = ({
  item,
  id,
}: {
  item: INewTicketAutoInactiveRule;
  id: string;
}) => {
  return GlobalAxios.put(TICKET_AUTO_INACTIVE_ROUTE + "/" + id, item);
};
